import * as Icons from "@phosphor-icons/react";
import { getGlobalStats, getSelectedBusinessId } from "selectors/businesses";
import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import Counter from "../Counter";
import DataStatuses from "const/DataStatuses";
import React from "react";
import UiRoutes from "const/UiRoutes";

const TransactionsNeedDocumentCounter = () => {
  const { uiTexts, messages } = useSelector(getTextsData);

  const globalStats = useSelector(getGlobalStats);

  const businessId = useSelector(getSelectedBusinessId);

  const {
    transactions: {
      needDocument: { count = 0 } = {}
    } = {}
  } = globalStats;

  return (
    <Counter
      to={`/${businessId}${UiRoutes.TRANSACTIONS}?status=${DataStatuses.NEED_DOCUMENT}`}
      color="#ee743d"
      mainText={count}
      secondaryText={uiTexts.transactions.toLowerCase()}
      description={messages.dashboardTxsNeedDocument}
      icon={Icons.FileSearch}
      loading={!globalStats.transactions} />
  );
};

export default React.memo(TransactionsNeedDocumentCounter);
